<template>
  <ListingBlockLayout title="Articles">
    <ArticleCardSkeleton v-for="i in numberOfCardsToRender" :key="i" />
  </ListingBlockLayout>
</template>

<script setup lang="ts">
import ListingBlockLayout from '@/app/components/listing/ListingBlockLayout.vue'
import ArticleCardSkeleton from '@/app/components/listing/skeleton-loaders/ArticleCardSkeleton.vue'

const numberOfCardsToRender = 3
</script>
